<template>
	<input
		type="text"
		class="form-control date"
		:id="id"
		:name="name"
		ref="datepickerInput"
	/>
</template>

<script>
import { EventBus } from "@/utils/event_bus.js";
import { initializeDatepicker } from "@/utils/helpers";
import dayjs from "dayjs";

export default {
	props: {
		id: String,
		name: String,
	},
	mounted() {
		const input = this.$refs.datepickerInput;

		if (!input) {
			return;
		}

		const datepicker = initializeDatepicker(input);

		input.addEventListener("changeDate", () => {
			let payload = {
				inputId: this.id,
				value: dayjs(datepicker.getDate()).format("YYYY/MM/DD"),
			};
			EventBus.$emit("date-input", payload);
		});
	},
};
</script>
